import React from "react";
import { getImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"
import BackgroundImage from "gatsby-background-image";


export const HeroSection = props => {
    let bgImage = null;
    let image = null;
    image = props.image;
    bgImage = getImage(image);
    if (!bgImage) {
        return null;
    }
    bgImage = convertToBgImage(bgImage);

    const contentProps = {}
    contentProps.className = ''
    if (props.gradientClass) {
        contentProps.className = props.gradientClass
    }
    if (props.contentClass) {
        contentProps.className += ` ${props.contentClass}`
    }
    if (props.style) {
        contentProps.style = props.style
    }
    const imgProps = props.imageStyle || {}

    const InnerContent = (props) => {
        return (
            <div {...contentProps}>
                {props.children}
            </div>
        )
    }

    return (
        <div className={props.parentClass}>
            <BackgroundImage
                Tag={props.tag}
                className={props.className}
                style={imgProps}
                {...bgImage}
            >
                <InnerContent {...props} />
            </BackgroundImage>
        </div>
    )
};

HeroSection.defaultProps = {
    tag: "div",
    parentClass: "",
    className: "",
    fileName: "",
    gradientClass: ""
};